module.exports = __webpack_public_path__ + "img/transparent-nav-right-honda.d9da815a.png";